// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","869":"styles"}[chunkId] + "-" + {"245":"35bd99e8ce5f0780c1bc","453":"3a7fb38611356337ab09","869":"da5d5fc1027abd8ad556"}[chunkId] + ".js";
};